import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import useRooms from '@/compositions/useRooms';
import { Selector } from '@/components/UI';
import { computed, ref, watch } from 'vue';
export default /*#__PURE__*/ _defineComponent({
    props: {
        modelValue: null,
        blackList: null,
        includePause: { type: Boolean }
    },
    emits: ["update:modelValue", "update"],
    setup(__props, { emit: emits }) {
        const props = __props;
        const roomId = ref(props.modelValue);
        watch(roomId, () => {
            emits('update:modelValue', roomId.value);
            emits('update', roomId.value);
        });
        const { rooms } = useRooms();
        const roomIds = computed(() => {
            let ids = Object.entries(rooms.value).map(([roomId, roomConfig]) => {
                return { text: roomConfig.name, value: roomId };
            });
            ids = ids.filter(option => { var _a; return !((_a = props.blackList) !== null && _a !== void 0 ? _a : []).includes(option.value); });
            if (props.includePause) {
                ids.push({ text: 'Pauze', value: 'pause' });
            }
            return ids;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(Selector), {
                modelValue: roomId.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((roomId).value = $event)),
                options: _unref(roomIds)
            }, null, 8, ["modelValue", "options"]));
        };
    }
});
